import React from "react";
import { useLocation } from "react-router-dom";
import { ShoppingCart, Menu } from "lucide-react";

const Header = ({ setShowCartModal, setShowContactModal, cartItemCount, setShowShareStoreModal }) => {
 const location = useLocation();
  
  // Map paths to custom titles
  const pageTitles = {
    '/store': 'Store',
    '/s': 'Store',
    '/product': 'Product Showcase',
    '/p': 'Product Showcase',

  };

  // Function to find the best matching title
  const getPageTitle = (pathname) => {
    // Exact match
    if (pageTitles[pathname]) {
      return pageTitles[pathname];
    }
    
    // Try to find a matching parent path
    const paths = pathname.split('/').filter(Boolean);
    for (let i = paths.length; i > 0; i--) {
      const testPath = '/' + paths.slice(0, i).join('/');
      if (pageTitles[testPath]) {
        return pageTitles[testPath];
      }
    }
    
    // Fallback: format the pathname
    return pathname
      .replace(/^\//, '')
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase())
      .replace(/\bApi\b/, 'API');
  };

  const currentPageTitle = getPageTitle(location.pathname);

    return (
        <div className="sticky top-0 z-50 bg-white/80 dark:bg-black/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-800 transition-colors duration-200">
            <div className="max-w-7xl mx-auto px-4 py-3">
                <div className="flex justify-between items-center">
                    {/* Store Name/Brand */}
                    <div 
                        className="text-lg font-bold text-black dark:text-white truncate max-w-[200px] sm:max-w-none"
                    >
                       {currentPageTitle || 'Store'}
                    </div>
                    
                    {/* Action Buttons */}
                    <div className="flex items-center space-x-2">
                        {/* Cart Button - Compact */}
                        <button
                            onClick={() => setShowCartModal(true)}
                            className="relative flex items-center gap-1.5 bg-blue-600 text-white font-bold px-4 py-2 rounded-full hover:bg-blue-700 shadow-lg shadow-blue-600/20 transition-all active:scale-95"
                        >
                            <ShoppingCart className="w-5 h-5" />
                            <span className="hidden sm:inline text-sm">Cart</span>
                            {cartItemCount > 0 && (
                                <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full border-2 border-white dark:border-black min-w-[18px] flex items-center justify-center">
                                    {cartItemCount}
                                </span>
                            )}
                        </button>

                        {/* Contact Button - Desktop */}
                        {/* <button
                            onClick={() => setShowContactModal(true)}
                            className="hidden sm:block px-4 py-2 bg-black dark:bg-white text-white dark:text-black rounded-full hover:opacity-90 transition-opacity text-sm font-bold"
                        >
                            Contact
                        </button> */}

                        {/* Share Button - Desktop */}
                        {/* <button 
                            onClick={() => setShowShareStoreModal(true)}  
                            className="hidden sm:block px-4 py-2 border border-gray-300 dark:border-gray-700 text-black dark:text-white rounded-full hover:bg-gray-100 dark:hover:bg-gray-900 transition-colors text-sm font-bold"
                        >
                            Share
                        </button> */}

                        {/* Mobile Menu Button for hidden items */}
                        <div className="sm:hidden">
                            <button
                                onClick={() => setShowContactModal(true)}
                                className="p-2.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300 transition-colors"
                            >
                                <Menu className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile-only full width buttons (Commented out as per original) */}
                {/* <div className="sm:hidden flex space-x-2 mt-3 pb-1">
                    <button
                        onClick={() => setShowContactModal(true)}
                        className="flex-1 px-4 py-2.5 bg-black dark:bg-white text-white dark:text-black rounded-xl hover:opacity-90 transition-opacity text-xs font-bold text-center"
                    >
                        Contact Store
                    </button>
                    <button 
                        onClick={() => setShowShareStoreModal(true)}  
                        className="flex-1 px-4 py-2.5 border border-gray-300 dark:border-gray-700 text-black dark:text-white rounded-xl hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors text-xs font-bold text-center"
                    >
                        Share Store
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default Header;